const GrupoUtils = {
    obterValoresDoFormulario(formRef) {
        let formValues = {...formRef.getFieldsValue(true)};
        formValues.proprietarios = formValues.proprietarios?.map(proprietario => proprietario?.key);
        formValues.membros = formValues.membros?.map(membro => membro?.key);
        return formValues;
    }
}

export default GrupoUtils;